<script setup lang="ts">
import Logo from '~/assets/icons/logo.svg'
const { locale } = useI18n()
const props = defineProps({
  error: Object,
})

useHead({
  htmlAttrs: {
    class: 'theme--storefront',
  },
})

const router = useRouter()
const localePath = useLocalePath()
</script>

<template>
  <div id="error" class="error-page">
    <div>
      <NuxtLink class="sf-header__logo" :to="`/${locale}/`" :aria-label="$t('Back to homepage')" data-testid="logoHome">
        <Logo />
      </NuxtLink>
    </div>
    <div class="error-page__content-container">
      <svg
        class="image"
        width="412"
        height="412"
        viewBox="0 0 412 412"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        alt="leaves"
      >
        <path
          d="M98.1707 164.285C98.1868 164.334 98.1868 164.382 98.2029 164.43C98.219 164.478 98.2672 164.494 98.2833 164.527C104.801 180.331 117.499 194.477 134.382 203.635C144.022 208.865 152.31 211.054 159.906 211.054C172.829 211.054 183.789 204.713 196.101 196.328L216.267 207.288C216.572 207.449 216.91 207.546 217.248 207.546C217.972 207.546 218.681 207.159 219.051 206.467C219.598 205.47 219.228 204.214 218.23 203.667L198.065 192.707C198.628 169.033 196.632 151.087 170.609 136.943C145.036 123.054 115.083 123.327 94.3061 137.619C94.0003 137.828 93.8072 138.102 93.6624 138.423C93.6302 138.488 93.6141 138.552 93.5819 138.617C93.5175 138.778 93.4693 138.938 93.4532 139.115C93.4532 139.164 93.421 139.212 93.421 139.26C93.1796 147.742 94.8855 156.223 98.1684 164.286L98.1707 164.285ZM116.839 132.371L120.637 150.622L99.5545 139.163C104.85 136.025 110.675 133.74 116.839 132.372L116.839 132.371ZM167.519 140.45L175.872 180.636L153.003 168.212L145.519 132.21C152.97 133.659 160.406 136.266 167.519 140C167.519 140.144 167.487 140.305 167.519 140.45L167.519 140.45ZM135.654 199.144C135.509 199.208 135.396 199.305 135.267 199.385C128.267 195.442 122.022 190.63 116.759 185.158L151.039 171.833L173.908 184.257L135.654 199.144ZM113.798 181.891C109.26 176.629 105.574 170.867 102.871 164.816L123.423 156.833L146.308 169.258L113.798 181.891ZM97.5757 142.799L118.675 154.258L101.277 161.017C99.0723 155.095 97.817 148.963 97.5756 142.799L97.5757 142.799ZM140.016 201.864L178.641 186.848L192.015 194.123C174.939 205.598 161.179 211.922 140.016 201.864H140.016ZM193.996 190.486L180.622 183.211L172.189 142.623C192.161 154.902 194.35 169.902 193.996 190.485V190.486ZM141.161 131.504L148.259 165.639L125.373 153.214L120.883 131.633C127.45 130.619 134.273 130.57 141.162 131.504L141.161 131.504Z"
          fill="#E9B9C4"
        />
        <path
          d="M295.145 184.658H295.161C295.193 184.675 295.209 184.691 295.241 184.707C295.563 184.9 295.917 184.98 296.271 184.98C296.545 184.98 296.835 184.916 297.108 184.803C302.451 182.437 307.231 178.881 311.271 174.455C311.303 174.423 311.335 174.423 311.351 174.391C311.383 174.359 311.399 174.31 311.432 174.278C319.318 165.571 324.355 153.533 325.063 140.384C326.174 120.106 316.533 112.413 302.645 104.254L303.465 89.0937C303.53 87.9511 302.661 86.9855 301.518 86.9211C300.279 86.8406 299.41 87.7258 299.345 88.8685L298.525 104.029C283.831 110.611 273.402 117.21 272.292 137.504C271.181 157.428 280.145 175.92 295.145 184.657L295.145 184.658ZM286.792 171.912L295.129 165.603L294.388 179.138C291.572 177.111 289.029 174.681 286.792 171.912L286.792 171.912ZM278.922 157.428L296.304 144.279L295.435 160.196L284.298 168.629C282.077 165.233 280.258 161.467 278.923 157.428H278.922ZM276.396 138.936L297.462 122.987L296.593 138.888L277.796 153.114C276.75 148.592 276.235 143.828 276.396 138.936H276.396ZM317.839 155.303L300.715 139.113L301.584 123.196L320.8 141.35C320.43 146.242 319.4 150.926 317.839 155.303L317.839 155.303ZM309.695 170.013L299.54 160.421L300.409 144.504L316.246 159.472C314.491 163.334 312.287 166.891 309.696 170.013H309.695ZM298.51 179.363L299.25 165.812L306.863 173.006C304.336 175.517 301.536 177.641 298.511 179.363H298.51ZM320.961 135.848L301.874 117.807L302.357 108.891C313.268 115.473 320.478 121.814 320.961 135.848H320.961ZM298.253 108.682L297.77 117.598L276.832 133.45C278.86 119.513 286.713 114.009 298.253 108.682L298.253 108.682Z"
          fill="#E9B9C4"
        />
        <path
          d="M220.63 289.348C220.614 289.252 220.614 289.123 220.582 289.042C220.566 289.01 220.582 288.994 220.566 288.962C220.55 288.93 220.533 288.914 220.533 288.897C220.485 288.817 220.437 288.737 220.389 288.64C220.324 288.543 220.276 288.431 220.196 288.35C220.147 288.302 220.115 288.27 220.083 288.222C220.067 288.205 220.067 288.173 220.051 288.173C211.811 280.48 201.865 274.703 190.937 270.873C190.873 270.84 190.824 270.792 190.76 270.776C190.68 270.744 190.583 270.744 190.486 270.728C168.985 263.308 143.704 263.518 119.688 272.241C86.4709 284.327 67.2532 308.564 62.4905 344.258L33.1033 354.928C32.0412 355.314 31.4779 356.505 31.8641 357.567C32.1699 358.404 32.9585 358.919 33.7954 358.919C34.0368 358.919 34.2621 358.871 34.5035 358.791L63.8746 348.104C81.6581 364.359 101.1 372.567 121.975 372.567C132.307 372.567 142.977 370.571 153.969 366.58C190.389 353.335 216.556 323.237 220.647 289.911C220.647 289.879 220.631 289.863 220.647 289.83V289.669C220.679 289.573 220.647 289.46 220.631 289.348L220.63 289.348ZM206.87 318.252L183.228 304.734L216.027 292.808C214.514 301.66 211.408 310.254 206.87 318.253L206.87 318.252ZM214.611 288.946L181.812 300.871L191.243 275.33C199.886 278.549 207.772 283.136 214.612 288.946H214.611ZM187.348 273.995L176.743 302.706L142.189 315.275L159.072 269.535C168.905 269.632 178.449 271.144 187.349 273.993L187.348 273.995ZM153.085 361.627L103.966 333.543L138.519 320.974L182.537 346.145C174.088 352.759 164.384 358.247 153.746 362.238C153.585 362.013 153.375 361.788 153.086 361.627L153.085 361.627ZM122.169 276.619C122.281 276.329 122.297 276.023 122.265 275.718C133 271.952 143.959 269.924 154.662 269.57L137.104 317.111L102.551 329.68L122.169 276.619ZM117.437 277.552L97.5133 331.516L66.903 342.653C71.7151 310.691 88.3076 289.336 117.439 277.553L117.437 277.552ZM68.2857 346.529L98.9121 335.409L148.867 363.975C118.981 373.648 92.5384 367.95 68.284 346.529H68.2857ZM185.932 343.359C185.932 343.343 185.932 343.343 185.916 343.343L143.591 319.138L178.161 306.569L204.731 321.777C199.742 329.679 193.401 336.97 185.934 343.359L185.932 343.359Z"
          fill="#E9B9C4"
        />
        <path
          d="M203.554 140.982C203.876 140.982 204.197 140.902 204.503 140.741C228.66 128.123 250.709 111.869 270.003 92.4749C270.808 91.6702 270.808 90.3666 269.987 89.562C269.182 88.7573 267.879 88.7573 267.074 89.5781C248.083 108.681 226.373 124.662 202.588 137.086C201.574 137.617 201.188 138.856 201.719 139.87C202.089 140.578 202.813 140.98 203.553 140.98L203.554 140.982Z"
          fill="#E9B9C4"
        />
        <path
          d="M277.181 83.9778C277.745 83.9778 278.308 83.7524 278.71 83.3018C281.06 80.7107 283.361 78.0554 285.598 75.3675C286.323 74.4985 286.21 73.1949 285.341 72.4707C284.472 71.7465 283.168 71.8591 282.444 72.7282C280.239 75.3836 277.97 77.9746 275.653 80.5496C274.896 81.3864 274.961 82.69 275.797 83.4625C276.184 83.8005 276.683 83.9775 277.182 83.9775L277.181 83.9778Z"
          fill="#E9B9C4"
        />
        <path
          d="M291.877 66.2087C292.505 66.2087 293.116 65.9351 293.519 65.3879C295.257 63.0865 296.963 60.7529 298.62 58.4033C299.28 57.4699 299.055 56.1984 298.138 55.5386C297.22 54.8949 295.933 55.1041 295.273 56.0375C293.631 58.355 291.958 60.6564 290.235 62.9097C289.543 63.8109 289.736 65.1145 290.638 65.7904C291.008 66.0801 291.442 66.2089 291.877 66.2089L291.877 66.2087Z"
          fill="#E9B9C4"
        />
        <path
          d="M301.485 50.6141C301.839 50.8394 302.225 50.9521 302.611 50.9521C303.287 50.9521 303.947 50.6302 304.333 50.0187C305.653 47.9908 306.957 45.9469 308.212 43.8708C308.807 42.9052 308.502 41.6338 307.536 41.0383C306.57 40.4428 305.299 40.7486 304.703 41.7142C303.448 43.7581 302.177 45.7699 300.873 47.7657C300.262 48.7313 300.519 50.0027 301.485 50.6143L301.485 50.6141Z"
          fill="#E9B9C4"
        />
        <path
          d="M376.399 88.7242C375.24 88.4667 374.194 89.1909 373.952 90.3014C357.907 165.042 311.654 231.799 247.052 273.464C246.103 274.076 245.813 275.363 246.441 276.313C246.843 276.924 247.503 277.262 248.179 277.262C248.565 277.262 248.951 277.166 249.289 276.941C314.777 234.678 361.687 166.974 377.973 91.1697C378.215 90.0592 377.507 88.9648 376.396 88.7234L376.399 88.7242Z"
          fill="#E9B9C4"
        />
        <path
          d="M380.086 66.8551C378.992 66.7102 377.914 67.4827 377.769 68.6093C377.511 70.4118 377.254 72.1982 376.98 74.0007C376.803 75.1273 377.576 76.1734 378.702 76.3504C378.815 76.3665 378.912 76.3826 379.024 76.3826C380.022 76.3826 380.891 75.6584 381.052 74.6445C381.326 72.8259 381.599 71.0073 381.857 69.1888C382.002 68.0461 381.213 67 380.086 66.8552V66.8551Z"
          fill="#E9B9C4"
        />
        <path
          d="M381.648 51.628C380.538 51.5475 379.524 52.3683 379.427 53.511C379.299 55.1203 379.154 56.7297 378.993 58.3392C378.88 59.4658 379.701 60.4796 380.827 60.5923C380.908 60.5923 380.972 60.6084 381.037 60.6084C382.083 60.6084 382.984 59.8198 383.08 58.7576C383.241 57.1322 383.386 55.4906 383.531 53.8491C383.612 52.7064 382.775 51.7247 381.648 51.6282V51.628Z"
          fill="#E9B9C4"
        />
        <path
          d="M382.197 42.4731H380.137L380.04 43.9538C379.96 45.0804 380.813 46.0781 381.94 46.1586H382.1C383.163 46.1586 384.08 45.3379 384.144 44.2435L384.241 42.7307L382.197 42.4731Z"
          fill="#E9B9C4"
        />
        <path
          d="M326.559 108.731C326.881 108.924 327.235 109.004 327.573 109.004C328.281 109.004 328.989 108.634 329.359 107.958C336.231 95.9201 342.089 83.1419 346.757 69.9448C347.143 68.8665 346.564 67.6917 345.501 67.3215C344.423 66.9513 343.248 67.4985 342.862 68.5768C338.275 81.5321 332.53 94.1014 325.771 105.914C325.223 106.912 325.561 108.167 326.559 108.731L326.559 108.731Z"
          fill="#E9B9C4"
        />
        <path
          d="M347.221 62.154C347.43 62.2184 347.623 62.2506 347.816 62.2506C348.701 62.2506 349.506 61.6873 349.78 60.8022C350.391 58.8066 350.987 56.8109 351.55 54.7993C351.856 53.705 351.212 52.5623 350.118 52.2565C349.023 51.9507 347.897 52.5945 347.591 53.6889C347.044 55.6684 346.464 57.6318 345.853 59.5953C345.515 60.6736 346.126 61.8323 347.221 62.1542L347.221 62.154Z"
          fill="#E9B9C4"
        />
        <path
          d="M351.136 48.3936C351.297 48.4258 351.458 48.458 351.619 48.458C352.553 48.458 353.389 47.8304 353.615 46.8808C353.904 45.6255 354.21 44.3863 354.484 43.131C354.725 42.0205 354.033 40.9261 352.923 40.6686C351.764 40.4272 350.718 41.1193 350.46 42.2297C350.187 43.4689 349.897 44.6921 349.607 45.9152C349.35 47.0095 350.026 48.12 351.136 48.3936V48.3936Z"
          fill="#E9B9C4"
        />
      </svg>

      <h2 class="heading sf-heading--no-underline">
        {{ props.error?.statusCode === 404 ? 'Woops!' : `An error ${props.error?.statusCode} occurred` }}
      </h2>
      <p class="text-center">
        {{
          props.error?.statusCode === 404
            ? $t('Sorry, the page you are looking for does not seem to exist anymore.')
            : $t('Please go back or try again')
        }}
      </p>
      <p v-if="props.error?.statusCode === 404" class="text-center">
        {{
          $t(
            'View our newest items & items that have been saved especially for you below! Or shop from one of our categories.',
          )
        }}
      </p>
      <div class="actions">
        <a class="sf-button actions__button sf-button--outline" :href="`${localePath('/')}/`">{{
          $t('Return home')
        }}</a>
        <button class="sf-button sf-button--full-width sf-button--text actions__button" @click="router.go(-1)">
          {{ $t('Go back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-page {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacer-sm);
  height: 100vh;
  width: 100vw;
}

.error-page__content-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.image {
  width: 14.375rem;
  margin: var(--spacer-xl) 0;

  @media screen and (min-width: 768px) {
    width: 25.75rem;
  }
}
.heading {
  --heading-title-margin: 0 0 var(--spacer-sm);
  --heading-title-color: var(--black-color);
  --heading-title-font-weight: var(--font-weight--semibold);
  --heading-description-color: var(--gray-primary-color);
  --heading-description-font-size: var(--font-size-sm);
  --heading-description-font-line-height: var(--global-line-height);
  --heading-description-margin: 0 var(--spacer-base);
  --heading-description-font-family: var(--font-family--primary);

  @media screen and (min-width: 768px) {
    --heading-description-margin: 0;
    --heading-description-font-size: var(--font-size--base);
  }
}

p {
  color: var(--gray-primary-color);
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
  margin: var(--spacer-xl) 0 0 0;
  &__button {
    --button-width: 100%;
    &:last-child {
      color: var(--cta-pink-color);
      margin: var(--spacer-sm) 0;

      &:hover,
      &:focus {
        opacity: 0.75;
      }
    }
  }
  @media screen and (min-width: 768px) {
    margin: var(--spacer-lg) 0 0 0;
    &__button {
      --button-width: auto;
      --button-min-width: 12rem;
    }
  }
}

.sf-header__logo {
  order: 0;

  svg {
    width: 70px;
    height: auto;
  }

  @media (min-width: 1024px) {
    align-items: center;
    display: inline-flex;

    svg {
      width: 108px;
    }
  }
}
</style>
